module.exports = __webpack_public_path__ + "img/ss-lazio.d4cb750f.png";